import { hasBenefitsUtilizedInflationCaveat } from '@shared';
import { WarningInfoDisclaimer } from './WarningInfoDisclaimer';

/**
 * Advisor guidance for the manually-entered Benefit Utilized To Date field on
 * CareMatters, where the figure is deducted from the base benefit amount
 * dollar-for-dollar but the inflation rider pays from a separate stream that
 * never depletes the pool — so a total-payments figure over-deducts by the whole
 * rider portion.
 *
 * Form-only and policy-type-only by design: the field has no extraction path, so
 * this is a note to an advisor typing a number, not a data-quality flag on saved
 * records. Scope lives in `hasBenefitsUtilizedInflationCaveat`.
 */
export function BenefitsUtilizedInflationWarning({
  policyType,
}: {
  policyType: FundingPolicyType | null | undefined;
}) {
  if (!hasBenefitsUtilizedInflationCaveat(policyType)) return null;

  return (
    <WarningInfoDisclaimer
      type="warning"
      bodyText={
        <p>
          <span className="font-semibold">Please note:</span> whatever amount is entered here is
          deducted dollar for dollar from the policy's base benefit amount. That would be incorrect
          if the amount includes payouts made by an inflation rider, so enter the base benefit
          dollars utilized rather than the total the carrier has paid out.
        </p>
      }
    />
  );
}
